<template>
  <div v-if="breadcrumb" class="course-breadcrumb">
    <ul>
      <li v-for="(item, i) in breadcrumb" :key="i">
        <nuxt-link v-if="item.slug.length" :to="item.slug">
          {{ item.name }}
        </nuxt-link>
        <span v-if="!item.slug.length">
          {{ item.name }}
        </span>
        <CaretRight v-if="item.slug.length" />
      </li>
    </ul>
  </div>
</template>

<script>
import CaretRight from '../../assets/svg/caret-right-white.svg?vue-component';

export default {
  components: { CaretRight },
  props: {
    breadcrumb: { type: Array, default: () => [], required: false },
  },
};
</script>

<style scoped lang="scss">
.course-breadcrumb {
  margin-bottom: var(--spacing-28);

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    justify-content: flex-start;

    li {
      display: flex;
      align-items: center;
      justify-content: space-between;

      a,
      span {
        text-decoration: none;
        font-weight: 500;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: 0.02em;
        text-transform: capitalize;
        color: var(--main-light-shade-4);
      }

      a {
        color: var(--main-light);
      }

      span {
        color: var(--main-light-shade-4);
      }
    }

    svg {
      vertical-align: middle;
      margin: 0 10px;
      width: 12px;
      height: 12px;
    }
  }

  @include bp($bp-mobile) {
    display: none;
  }
}

.fa .course-breadcrumb ul li span {
  color: var(--main-dark-light-4);
}
</style>
